module.exports = __webpack_public_path__ + "static/media/hdfc_banner.0ea4f1c9.png";